import { render, staticRenderFns } from "./DynamicNotification.vue?vue&type=template&id=bc48027c"
import script from "./DynamicNotification.vue?vue&type=script&lang=js"
export * from "./DynamicNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports